import { useTheme } from "@mui/material";

import { InformationIconFilled } from "@/Components/Icons/Info";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Tooltip } from "@/Components/v2/atoms/ToolTip";
import { Typography } from "@/Components/v2/atoms/Typography";

const HeaderInfoTooltip = () => {
  const theme = useTheme();
  return (
    <Tooltip
      title={
        <Typography padding={1} sx={{ color: theme.palette.common.white }}>
          These numbers are taken from the current spend and revenue points on your saturation
          curves, which compare adstocked spend with total sales, and account for delayed marketing
          effects, pricing, and external factors.
          <br />
          <Typography component="span" fontWeight={600} sx={{ color: theme.palette.common.white }}>
            They may differ from other figures in the platform
          </Typography>
          <br />
          In particular, revenue is expected total revenue at that level of spend not the actual for
          the measurement period.
        </Typography>
      }
      placement="bottom"
    >
      <span style={{ color: theme.palette.hyperLink.textColor, textDecoration: "underline" }}>
        <Stack direction="row" gap={1}>
          <InformationIconFilled />
          What do these numbers mean?
        </Stack>
      </span>
    </Tooltip>
  );
};

export default HeaderInfoTooltip;
